export const getMaskText = (value = '', mask: string): string => {
  const lengthDiff = value.length - mask.length;
  if (lengthDiff > 0) {
    return '';
  }

  const maskStart = mask.length - Math.abs(lengthDiff);
  return `${value}${mask.substring(maskStart)}`;
};
